<template>
   <!-- 领奖页 -->
   <div class="award bg">
      <div class="top bg">
         <span @click="gooff">返回</span>
         <span><img style="width: 3%;" src="../../static/pageImg/common/common_icon_back.png" alt=""></span>
      </div>
      <div class="content">
         <div class="content_top bg">
            <p> 请输入您的<span style="color:#FFF777">领奖信息</span> </p>
         </div>
         <div class="form_box">
            <div class="name_bg bg">
               <div class="name_title"><span>姓名</span></div>
               <div class="name_input">
                  <input type="text" placeholder="请输入您的姓名" v-model="formData.name">
               </div>
            </div>
            <div class="name_bg bg">
               <div class="name_title"><span>手机号</span></div>
               <div class="name_input">
                  <input type="text" placeholder="请输入您的手机号" v-model="formData.phone">
               </div>
               <div class="check_tip" v-if="checkPhone"><span>手机号不能为空！</span></div>
            </div>
            <div class="name_bg bg">
               <div class="name_title"><span>邮箱</span></div>
               <div class="name_input">
                  <input type="text" placeholder="请输入您的邮箱" v-model="formData.email">
                  <div class="check_tip" v-if="checkEmail"><span>请输入正确的邮箱地址</span></div>
               </div>
            </div>
            <div class="tarea_bg bg">
               <div class="tarea_title"><span>领奖地址</span></div>
               <div class="input_tarea">
                  <!-- <input type="a" placeholder="请输入您的手机号" :value="formData.adress"> -->
                  <textarea placeholder="请输入领奖地址，方便我们邮寄奖品给您（您的奖品或根据类型，以邮箱形式发放，请注意电子邮件消息）" v-model="formData.address"></textarea>
               </div>
            </div>
            <div class="check_tip" v-if="checkAddress"><span>收货地址不能为空！</span></div>
         </div>
      </div>
      <div class="submit bg" @touchend="submit()"></div>
      <div class="bottom bg">
         <div class="bottom_title">
            提示
         </div>
         <div class="bottom_content">
            请于<span class="span1">{{EndTime}}</span>提交领奖信息，过时将不可领奖！如果您有任何问题，请通过封面新闻客户端<span class="span2">“我的-求助小封”</span>与我们联系
         </div>
      </div>
   </div>
</template>
<script>
   // @ts-nocheck # 忽略全文
   import { mapState, mapMutations } from "vuex";
   import { Options, Vue } from 'vue-class-component'
   import COVERAPP from '@/utils/COVERAPP'
   export default {
      data() {
         return {
            formData: {
               name: '',
               phone: '',
               address: '',
               email: '',
               origin: '排行榜'
            },
            checkAddress: false,
            checkEmail: false,
            checkPhone: false,
            // 排行榜领奖 11月7日24：00     抽奖码领奖10月29日17：00
            EndTime: "2022年11月7日中午24:00前",
            submitStatus: true,
            fullPathXXX: ''
         }
      },
      beforeRouteEnter(to, from, next) {
         if (from.fullPath != "/test") {
            next(vm => {
               vm.fullPathXXX = from.fullPath
               vm.formData.origin = "抽奖码"
               vm.EndTime = "10月29日17:00前"
            })
         } else {
            next(vm => {
               vm.formData.origin = "排行榜"
               vm.EndTime = "2022年11月7日中午24:00前"
            })
         }
      },
      mounted() {
         this.$common.pageLoaded()
         if (this.fullPathXXX != "/test") {
            if (!COVERAPP.Attribute.isApp()) {
               const Timer = setInterval(() => {
                  try {
                     this.$common.downloadApp(this.activityData.openApp.news_id, this.activityData.openApp.flag);
                     clearInterval(Timer)
                     this.SET_DIALOGDATA({
                        text: '请前往封面新闻APP打开'
                     })
                  } catch (e) { console.log(e); }
               }, 300)
            }else{
               this.checkUserSSS()
            }
         } else {
            this.checkUserSSS()
         }
      },
      computed: {
         ...mapState([
            "activityData",
            "aid",
            "userInfo"
         ]),
      },
      methods: {
         ...mapMutations([
            "SET_USERINFO",
            "SET_SHAREDATA",
            "SET_DIALOGDATA",
            "SET_ACTIVITYDATA",
            "SET_FIRSTLOGINSTATUS",
            "SET_LOADINGSTATUS",
         ]),
         gooff() {
            this.$router.go(-1)
         },
         submit() {
            let usr = sessionStorage.getItem("COVER_USERINFO");
            var user;
            if (usr != null) {
               user = JSON.parse(usr);
            }
            var reg = new RegExp(/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/)
            if (reg.test(this.formData.email)) {
               this.checkEmail = false
            } else {
               this.checkEmail = true
            }
            if (this.formData.address === '') {
               this.checkAddress = true
            } else {
               this.checkAddress = false
            }
            if (this.formData.phone === '') {
               this.checkPhone = true
            } else {
               this.checkPhone = false
            }
            if (this.checkAddress == false && this.checkEmail == false && this.checkPhone == false) {
               this.submitAPI()
            }
         },
         async submitAPI() {
            const submitStatus = this.submitStatus
            if (submitStatus) {
               let usr = sessionStorage.getItem("COVER_USERINFO");
               var user;
               if (usr != null) {
                  user = JSON.parse(usr);
               }
               const formData = this.formData
               var token = ''
               if (COVERAPP.Attribute.isWeixin()) {
                  token = user.openid
               } else {
                  token = user.token
               }
               let usrdata = await this.$request(
                  "/apply",
                  { "aid": this.aid, "userinfo": user, "token": token, "info": formData },
                  "post"
               ).catch((res) => {
                  this.$common.toast(res.errmsg)
                  this.formData.name = ''
                  this.formData.phone = ''
                  this.formData.address = ''
                  this.formData.email = ''
               });
               if (usrdata) {
                  this.$common.toast("提交成功");
                  this.formData.name = ''
                  this.formData.phone = ''
                  this.formData.address = ''
                  this.formData.email = ''
               }
            } else {
               this.$common.toast("您未中奖");
            }
         },
         async checkUserSSS() {
            const _this = this
            const nowData = new Date();
            const endTime = _this.dateFormat(_this.activityData.templateConfig.awardEndTime);
            const nowTime = _this.dateFormat(nowData);
            const rep_endTime = endTime
               .replace(/\-/g, "")
               .replace(/ /g, "")
               .replace(/\:/g, "");
            const rep_nowTime = nowTime
               .replace(/\-/g, "")
               .replace(/ /g, "")
               .replace(/\:/g, "");
            if (rep_endTime < rep_nowTime) {
               this.SET_DIALOGDATA({
                  text: '很抱歉，领奖时间已截止'
               })
               return;
            }

            if (!_this.userInfo || !_this.userInfo.token) {
               _this.openLogin().then(() => {
                  _this.getUser();
               });
               return;
            }

            let usr = sessionStorage.getItem("COVER_USERINFO");
            let user = JSON.parse(usr);
            let usrGamedata = await this.$request(
               "/temporary/dggcwlj/user",
               { aid: _this.aid, userinfo: user },
               "post"
            ).catch((res) => {
               console.log("用户游戏信息测试数据错误", res);
            });
            if( !usrGamedata.prize ){
               _this.$common.toast("您未中奖");
               _this.submitStatus = false
            }
         },
         //时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
         dateFormat(time) {
            var date = new Date(time);
            var year = date.getFullYear();
            /* 在日期格式中，月份是从0开始的，因此要加0
             * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
             * */
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
         },
         openLogin() {
            const _this = this;
            return new Promise((resolve) => {
               COVERAPP.Method.OpenLogin({
                  callback(user) {
                     if (user && (user.token || user.userid)) {
                        _this.SET_USERINFO(user);
                     }
                     resolve(user);
                  },
               });
            });
         },
         checkLogin() {
            if (!this.userInfo || !this.userInfo.token) {
               this.openLogin().then(() => {
                  this.getUser();
               });
               return;
            }
         },
      }
   }
</script>
<style lang="less" scoped>
   .bg {
      background-size: 100% 100%;
      padding: 0px;
      overflow: hidden;
      background-repeat: no-repeat;
   }
   .award {
      width: 100%;
      // height: 100vh;
      background-image: url("../../static/pageImg/common/common_bg_ganzhuao.png");
      .top {
         margin-top: 4vw;
         line-height: 10vw;
         width: 100%;
         background-image: url("../../static/pageImg/领奖/award_btn_back.png");
         span {
            font-size: 4vw;
            color: #ffffff;
            font-weight: bold;
            margin: 10px 0;
            padding-left: 10px;
            width: 20%;
         }
      }
      .content {
         width: 92vw;
         height: 112vw;
         margin: 0 auto;
         margin-top: 3vw;
         background-color: #ffffff;
         border-radius: 6px;
         .content_top {
            height: 14vw;
            line-height: 16vw;
            background-image: url("../../static/pageImg/领奖/award_title_bg.png");
            p {
               font-size: 21px;
               font-weight: bold;
               text-align: center;
               color: #ffffff;
            }
         }
      }
      .form_box {
         width: 84vw;
         margin: 0 auto;
      }
      .check_tip {
         position: relative;
         color: #f51717;
         font-weight: 400;
         font-size: 12px;
         position: absolute;
      }
      .name_bg {
         height: 14vw;
         margin-top: 5vw;
         background-image: url("../../static/pageImg/领奖/award_edit.png");
         .name_title {
            font-size: 3.5vw;
            color: #ffffff;
            height: 5vw;
            line-height: 5vw;
            font-weight: 400;

            span {
               margin-left: 3vw;
            }
         }
         .name_input {
            height: 9vw;
            border: 1px solid #d3d3d3;
            border-radius: 4px;
            input {
               height: 9vw;
               width: 93vw;
               font-size: 15px;
               color: rgb(0, 0, 0);
               padding: 0px 10px;
               border: none;
               outline: none;
            }
            input::-webkit-input-placeholder {
               color: #c1c1c1;
               margin-top: 20px;
            }
         }
         .input_tarea {
            height: 125px;
         }
      }
      .tarea_bg {
         // height: 145px;
         margin-top: 7.72%;
         background-image: url("../../static/pageImg/领奖/award_edit_address.png");
         .tarea_title {
            font-size: 3.5vw;
            color: #ffffff;
            height: 5vw;
            line-height: 5vw;
            font-weight: 400;

            span {
               margin-left: 10px;
            }
         }
         .input_tarea {
            height: 22vw;
            border: 1px solid #d3d3d3;
            border-radius: 1px;
            textarea {
               height: 19.5vw;
               width: 81.5vw;
               resize: none;
               border: none;
               font-size: 15px;
               padding: 10px;
               outline: none;
            }
            textarea::-webkit-input-placeholder {
               font-size: 15px;
               font-weight: 400;
               color: #c1c1c1;
            }
         }
      }
      .submit {
         height: 49px;
         width: 229px;
         margin: 0 auto;
         margin-top: 5.7%;
         background-image: url("../../static/pageImg/领奖/award_btn_next.png");
      }
      .bottom {
         padding: 10px 26px;
         height: 16.42%;
         width: 76.93%;
         margin: 0 auto;
         margin-top: 3.5%;
         margin-bottom: 10vw;
         background-image: url("../../static/pageImg/领奖/award_message_bg_s.png");
         .bottom_title {
            color: #ffe63b;
            font-size: 19px;
            font-weight: bold;
            letter-spacing: 3px;
         }
         .bottom_content {
            color: #ffffff;
            // margin-top: 15px;
            font-size: 13px;
            line-height: 23px;
            .span1 {
               color: #ffe63b;
               font-weight: bold;
               letter-spacing: 1px;
            }
            .span2 {
               font-weight: bold;
               letter-spacing: 1px;
            }
         }
      }
   }
</style>